import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import "./styles/index.scss"
import { Router } from "./routes"
import { AuthProvider } from "./components/templates/AuthProvider"
import { ErrorBoundary } from "./components/templates/ErrorBoundary"
import * as Sentry from "@sentry/react"
import Config from "./config"
import { Elements as StripeElements } from "@stripe/react-stripe-js"
import { loadStripe } from "@stripe/stripe-js"
import { DndProvider } from "react-dnd"
import { HTML5Backend } from "react-dnd-html5-backend"
import { HelmetProvider } from "react-helmet-async"

Sentry.init({
  dsn: Config.sentryDsn,
  integrations: [],
})

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 60 * 1000 * 10 } },
})

const stripePromise = loadStripe(Config.stripePublicKey)

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <ErrorBoundary>
            <AuthProvider>
              <StripeElements
                stripe={stripePromise}
                options={{
                  mode: "subscription",
                  // @TODO dynamically update stripe subscription amount based on selected price
                  amount: 2500,
                  currency: "usd",
                }}
              >
                <DndProvider backend={HTML5Backend}>
                  <Router />
                </DndProvider>
              </StripeElements>
            </AuthProvider>
          </ErrorBoundary>
        </BrowserRouter>
      </QueryClientProvider>
    </HelmetProvider>
  </StrictMode>,
)
